@if (!loadError) {
  <div>
    <ng-content></ng-content>
  </div>
}
@if (loadError) {
  <div>
    <em>An error occurred, please try reloading the page.</em>
  </div>
}